<div class="modal-header">
  <h1 class="modal-title" id="modal-basic-title">
    {{ titleModal | translate }}
  </h1>
  <button
    class="cdx-button cdx-button--icon"
    aria-label="Close"
    (click)="modalClose()"
  >
    <fa-icon class="fa-fw cdx-button__icon" [icon]="['far', 'times']"></fa-icon>
  </button>
</div>

<div class="modal-body">
  <p class="mb-4">
    {{ subTitle | translate }}
  </p>

  <app-contact-table
    (addButtonClick)="buttonsHeaderAddClick()"
    (searchValueChanged)="search($event)"
    (removeButtonClick)="showConfirmationDelete($event)"
    (editButtonClick)="fillForm($event)"
    (onTableScroll)="onTableScroll()"
    (onTableChange)="onTableChange($event)"
    [elements]="elements"
    [showSignatureType]="showSignatureType"
    [showSubscriberType]="showSubscriberType"
    [showSSN] = "showSSN"
    [showTelephone] = "showTelephone"
    [enableEditContact]="enableEditContact"
    [participantType]="participantTypeInput"
  ></app-contact-table>
</div>

<div class="modal-footer pr-3">
  <button class="cdx-button cdx-button--tertiary ml-0" (click)="modalClose()">
    <span class="cdx-button__text">{{ "cancel" | translate | uppercase }}</span>
  </button>

  <button
    class="cdx-button cdx-button--primary ml-0"
    [disabled]="elementsSelecteds.length == 0"
    (click)="modalSubmit()"
  >
    <span class="cdx-button__text">{{ "add" | translate | uppercase }}</span>
  </button>
</div>

<ngx-loading [show]="loading"></ngx-loading>

<ng-template #confirmDeleteModal>
  <app-confirm-modal
    [HeaderText]="headerTextConfirmDeleteModal"
    [QuestionText]="questionTextConfirmDeleteModal"
    [MessageText]="messageTextConfirmDeleteModal"
    (closeModalClick)="confirmModalClose()"
    (confirmModalClick)="confirmModalYesClick()"
    [ButtonConfirmText]="'yes'"
    [ButtonCancelText]="'no'"
    [IsApprovalConfirm]="false"
  >
  </app-confirm-modal>
</ng-template>

<ng-template #addSignatoryModal>
  <app-contact-form
    (modalCloseEmitter)="closeCreateSignatoryModal()"
    (addSignatoryToTable)="addSignatoryToTable($event)"
    [userToEdit]="userToEditSignatory"
    [elements]="elements"
    [participantType] = "participantTypeInput"
  ></app-contact-form>
</ng-template>

<ng-template #addAuthorizerModal>
  <app-contact-form
    (modalCloseEmitter)="closeCreateSignatoryModal()"
    (addSignatoryToTable)="addAuthorizerToTable($event)"
    [userToEdit]="userToEditAuthorizer"
    [elements]="elements"
    [participantType] = "participantTypeInput"
  ></app-contact-form>
</ng-template>

<ng-template #addObserverModal>
  <app-contact-form
    (modalCloseEmitter)="closeCreateSignatoryModal()"
    (addSignatoryToTable)="addObserverToTable($event)"
    [userToEdit]="userToEditObserver"
    [elements]="elements"
    [participantType] = "participantTypeInput"
  >
  </app-contact-form>
</ng-template>

<ng-template #addResponsibleModal>
  <app-contact-form
    (modalCloseEmitter)="closeCreateSignatoryModal()"
    (addSignatoryToTable)="addResponsibleToTable($event)"
    [userToEdit]="userToEditResponsible"
    [elements]="elements"
    [participantType]="participantTypeInput"
  >
  </app-contact-form>
</ng-template>
